import { gsap } from 'gsap'
import { CustomEase } from 'gsap/CustomEase'

export class Video {

  isCallable () {
    return window.innerWidth > 1024
  }

  init () {
    gsap.registerPlugin(CustomEase)
    gsap.fromTo('video',
      {
        clipPath: 'inset(50%)',
      },
      {
        duration: 2,
        clipPath: 'inset(0%)',
        ease: CustomEase.create('custom', 'M0,0 C0.104,0.204 -0.125,1.04 1,1 ')
      })
  }
}
